/**
 * Points per catch by train size (1–5 emojis). Catching a 1-emoji train = more points than 5-emoji (harder/smaller target).
 */
export const POINTS_PER_TRAIN_SIZE: Record<number, number> = {
  1: 50,
  2: 40,
  3: 30,
  4: 20,
  5: 10,
};

export function getPointsForTrainSize(emojiCount: number): number {
  return POINTS_PER_TRAIN_SIZE[emojiCount] ?? 10;
}

/** Game tuning: easy to change speed, size, position, animations. */
export const CATCH_THE_TRAIN_CONFIG = {
  /** Duration (ms) per pass — longer train = faster (shorter duration). 1 emoji = slowest, 5 = fastest. */
  firstPassDurationMs: 900,
  secondPassDurationMs: 800,
  thirdPassDurationMs: 700,
  fourthPassDurationMs: 600,
  fifthPassDurationMs: 500,
  /** Delay (ms) between passes. */
  delayAfterFirstPassMs: 280,
  delayAfterSecondPassMs: 280,
  delayAfterThirdPassMs: 280,
  delayAfterFourthPassMs: 280,
  /** Delay (ms) after full run (1→2→3→4→5) before next run. */
  delayBetweenRunsMs: 280,
  /** Vertical positions (0–1): top, upper-mid, middle, lower-mid, bottom; one picked per pass. */
  verticalPositions: [0.12, 0.3, 0.5, 0.7, 0.88],
  /** Horizontal catch zone: train is catchable when its center is in [catchZoneStart, catchZoneEnd]. */
  catchZoneStart: 0.35,
  catchZoneEnd: 0.65,
  /** Emoji font size (px) in the train wrapper. */
  emojiSizePx: 52,
  /** Wrapper animation types (cycle through or random). */
  animationTypes: ['blink', 'zoomInOut', 'colorShift', 'pulse', 'shake'] as const,
} as const;

export type TrainWrapperAnimation = (typeof CATCH_THE_TRAIN_CONFIG.animationTypes)[number];
